export default __webpack_public_path__ + "assets/c22430f919fdb49404bd5c0402a6e888.woff2";